import { Injectable, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private toastr = inject(ToastrService);
  private transloco = inject(TranslocoService);

  showSuccess(message: string, title?: string): void {
    this.toastr.success(
      message,
      title ?? this.transloco.translate('notification.success.title')
    );
  }

  showError(message: string, title?: string): void {
    this.toastr.error(
      message,
      title ?? this.transloco.translate('notification.error.title')
    );
  }

  showInfo(message: string, title: string): void {
    this.toastr.info(message, title);
  }

  showWarning(message: string, title: string): void {
    this.toastr.warning(message, title);
  }
}
